import { IDiamond } from 'types/diamond.types'
import { shapes } from './diamond-attributes'
import { YadavRelatedDiamond } from '@commerce/types/diamond'

const formatDiamondTitle = (
  diamond: IDiamond | YadavRelatedDiamond,
  withShape: boolean = false
) => {
  const shapeName = shapes[diamond.shape!.toUpperCase() as keyof typeof shapes]
  const diamondType = diamond.labcreated ? 'Lab Created' : 'Natural'

  if (withShape) {
    return `${diamond.weight} Carat ${shapeName} ${diamondType} Diamond`
  } else {
    return `${diamond.weight} Carat ${diamondType} Diamond`
  }
}

export default formatDiamondTitle
